import { SelectButtonOption } from 'ui';

export enum DateRange {
  LastYear = 'last_year',
  LastQuarter = 'last_quarter',
  CurrentQuarter = 'current_quarter',
  All = 'all',
}

export const chartDateRangeOptions: SelectButtonOption<DateRange>[] = [
  { label: 'Last Year', value: DateRange.LastYear },
  { label: 'Last Quarter', value: DateRange.LastQuarter },
  { label: 'Current Quarter', value: DateRange.CurrentQuarter },
  { label: 'All', value: DateRange.All },
];
